import { render } from "./AccessoryList.vue?vue&type=template&id=32b12d20&scoped=true"
import script from "./AccessoryList.vue?vue&type=script&lang=js"
export * from "./AccessoryList.vue?vue&type=script&lang=js"

import "./AccessoryList.vue?vue&type=style&index=0&id=32b12d20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b12d20"]])

export default __exports__